/* APIRoutes
* Use create/retrieve/update/delete keywords for api prop name and follow the module screen hierarchy.
* if same api is used for multiple operations, define it once with the prop name in short form
*  (e.g cu, cd,cud, crud)
*/

export const APIRoutes = {
    PurchaseOrders: {
        diary: {
            lines: {
                retrieve: 'Diary/GetDiaries/porder/Key/:PurchaseOrder',
                update: 'Diary/:DiaryId',
                delete: 'Diary/:DiaryId',
            },
            detail: {
                retrieve: 'Diary/:DiaryId',
                create: 'Diary/porder/Key/:PurchaseOrder'
            }
        }
    },
    PickSlips: {
        diary: {
            lines: {
                retrieve: 'Diary/GetDiaries/debinvdesp/Key/:DespatchId',
                update: 'Diary/:DiaryId',
                delete: 'Diary/:DiaryId',
            },
            detail: {
                retrieve: 'Diary/:DiaryId',
                create: 'Diary/debinvdesp/Key/:DespatchId'
            }
        }
    },
};
